import React from 'react';

import { Favicon } from 'components/Favicon';

/**
 * Default panelfox app favicon.
 */
export function PrivatePanelsFavicon() {
    return <Favicon href="/favicon.ico" />;
}
